import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
function ConsultMenu() {
    const userGroup = localStorage.getItem("userGroup");
    const MenuCard = ({link, title, icon, color}) => (
        <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
            <Link to={link} className="menu-link">
                <div className="menu-card" style={{borderTop: `4px solid ${color}`}}>
                    <div className="menu-icon" style={{color: color}}>
                        <FontAwesomeIcon icon={icon} size="2x"/>
                    </div>
                    <p className="menu-title">{title}</p>
                </div>
            </Link>
        </div>
    );
    return (
        <section className="container-fluid mt-4">

            {/* ✅ ADMIN ONLY SECTION */}
            {userGroup === "Admin" && (
                <>
                    <h5 className="menu-section-title">Consultant Master</h5>

                    <div className="row">
                        <MenuCard link="/add-consultant" title="Add Consultant" icon="fa-solid fa-user-doctor"
                                  color="#0d6efd"/>
                        <MenuCard link="/add-ref-consultant" title="Reference Consultant" icon="fa-solid fa-user-plus"
                                  color="#20c997"/>
                        <MenuCard link="/add-cons-dept" title="Department" icon="fa-solid fa-building" color="#6f42c1"/>
                        <MenuCard link="/cons-search" title="Consultant Payment" icon="fa-solid fa-money-check-dollar"
                                  color="#dc3545"/>
                        <MenuCard link="/cons-pay-report" title="Payment Report" icon="fa-solid fa-chart-line"
                                  color="#fd7e14"/>
                    </div>
                </>
            )}

            {/* ALWAYS VISIBLE */}
            <h5 className="menu-section-title">Out Patients</h5>
            <div className="row">
                <MenuCard link="/cons-view" title="OP Patients" icon="fa-solid fa-user-injured" color="#0dcaf0"/>
                <MenuCard link="/pat-search" title="Patient Records" icon="fa-solid fa-file-medical" color="#6610f2"/>
                <MenuCard
                    link="/telemedicine-consultations"
                    title="Telemedicine Consultations"
                    icon="fa-solid fa-video"
                    color="#198754"
                />
            </div>

            <h5 className="menu-section-title">In Patients</h5>
            <div className="row">
                <MenuCard link="/ip-view" title="In Patients" icon="fa-solid fa-bed" color="#20c997"/>
                <MenuCard link="/discharge-list-date" title="Discharge Summary" icon="fa-solid fa-file-waveform"
                          color="#dc3545"/>
            </div>

        </section>
    );
}
export default ConsultMenu;